import type { FunctionComponent } from 'react';
import { useInternalContext } from '../../../context/InternalContext';
import EmptyState from '../EmptyState/EmptyState';

type FlashSalesProps = {
  isOnOwnPage: boolean;
  closeCart: () => void;
};

const FlashSales: FunctionComponent<FlashSalesProps> = ({ isOnOwnPage, closeCart }) => {
  const { hostname } = useInternalContext();
  const buttonAction = isOnOwnPage
    ? closeCart
    : () => {
        window.location.href = `https://${hostname}/add-ons`;
      };

  return (
    <EmptyState
      icon="fal fa-box"
      title="Add-Ons is Closed"
      description="Find out more about Add-Ons."
      cta="Learn More"
      action={buttonAction}
    />
  );
};

export default FlashSales;
